import useSeo from "@/lib/useSeo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BundlesHero from "@/components/bundles/BundlesHero";
import BundlesIncluded from "@/components/bundles/BundlesIncluded";
import BundlesWhy from "@/components/bundles/BundlesWhy";
import BundlesWho from "@/components/bundles/BundlesWho";
import BundlesBenefits from "@/components/bundles/BundlesBenefits";
import BundlesProcess from "@/components/bundles/BundlesProcess";
import BundlesCTA from "@/components/bundles/BundlesCTA";

export default function BundlesPage() {
  useSeo({
    title: "Bundles — ED Tech Depot | Complete In-House Print Systems for K-12",
    description:
      "Printer, supplies, and finishing tools — bundled into one complete system for your K-12 school. 24\", 36\", or 44\" Canon printer, 1–2 year supply kit, laminator, vinyl cutter, and banner finishing kit.",
    path: "/bundles",
  });

  return (
    <div data-testid="bundles-page" className="min-h-screen bg-[#F4F6F4]">
      <Header />
      <main>
        <BundlesHero />
        <BundlesIncluded />
        <BundlesWhy />
        <BundlesWho />
        <BundlesBenefits />
        <BundlesProcess />
        <BundlesCTA />
      </main>
      <Footer />
    </div>
  );
}
